// import { useEffect } from "react";
// import { useSelector } from "react-redux";
import "../../style/mobile/dashboard/M_Dashboard.css";
import MAds from "./M_Ads";
import MBlog from "./M_Blog";
import MDateBox from "./M_DateBox";
import MExamStore from "./M_ExamStore";
import MMyExam from "./M_MyExam";
import MQuickAccess from "./M_Quick_Access";
import MSearch from "./M_Search";


const M_Dashboard = () => {
  return (
    <div className="m-dashboard">
      <MSearch />
      <MQuickAccess />
      <MDateBox />
      <MMyExam />
      <MExamStore />
      <MBlog />
      <MAds />
    </div>
  );
};

export default M_Dashboard;
